import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Form,
  Grid,
  Image,
  Divider,
  Button,
  Loader,
  Dropdown
} from 'semantic-ui-react';
import _ from 'lodash';

import * as AppActions from '../../actions';
import Images from '../../assets/Images';
import { generatePassword } from '../../utils/password';
import {
  addUser,
  updateUser,
  getGroupsForUser
} from '../../services/UserManagementService';
import './ManageUser.css';

class ManageUser extends Component {
  state = {
    message: '',
    groups: [],
    errorMessage: '',
    processing: false,
    form: {
      given_name: '',
      family_name: '',
      email: '',
      group: '',
      phone: '',
      oldGroup: ''
    }
  };

  componentDidMount() {
    this.getGroups();
    if (this.props.userToEdit) {
      this.initializeEdit(this.props.userToEdit);
    }
  }

  initializeEdit = async (userToEdit) => {
    let form = this.state.form;
    form.given_name = this.getAttribute(userToEdit, 'given_name');
    form.family_name = this.getAttribute(userToEdit, 'family_name');
    form.email = this.getAttribute(userToEdit, 'email');
    form.phone = this.getAttribute(userToEdit, 'phone_number');

    const userData = {
      requester: this.props.user.email.trim(),
      username: userToEdit.Username
    };
    const result = await getGroupsForUser(userData);

    if (result.statusCode === 200 && result.group.Groups) {
      form.group = result.group.Groups[0].GroupName;
      form.oldGroup = form.group;
    }

    this.setState({ form });
  };

  getGroups = async () => {
    const groups = _.sortBy(
      _.map(this.props.groups, (op, index) => ({
        key: index,
        value: op.GroupName,
        text: op.GroupName
      })),
      'text'
    );

    this.setState({ groups });
  };

  clearFields = () => {
    const form = {
      given_name: '',
      family_name: '',
      email: '',
      group: '',
      phone: '',
      oldGroup: ''
    };

    this.setState({ form });
  };

  getAttribute = (user, field) => {
    const attribute = user.Attributes.find(
      (attribute) => attribute.Name === field
    );
    return attribute ? attribute.Value : '';
  };

  handleFormChange = (event, { name, value }) => {
    if (name === 'phone') {
      let phoneVal;
      if (value !== '' && value[0] !== '+') {
        phoneVal = `+1 ${value}`;
      } else {
        phoneVal = `+1 ${value.slice(3)}`;
      }
      this.setState({ form: { ...this.state.form, [name]: phoneVal } });
    } else {
      this.setState({ form: { ...this.state.form, [name]: value } });
    }
  };

  goBackSearch = () => {
    this.clearFields();
    this.props.searchPage();
  };

  createEditUser = async () => {
    const {
      given_name,
      family_name,
      email,
      group,
      oldGroup,
      phone
    } = this.state.form;
    const { userToEdit } = this.props;
    this.setState({ message: '', errorMessage: '', processing: true });

    if (!this.validFields()) {
      this.setState({
        errorMessage: 'All the fields are required',
        processing: false
      });
      return;
    }

    if (!this.validEmail()) {
      this.setState({
        errorMessage: 'The email is not valid',
        processing: false
      });
      return;
    }

    const tempPassword = generatePassword();
    const userData = {
      requester: this.props.user.email.trim(),
      username: userToEdit ? userToEdit.Username : email,
      group,
      attributeList: [
        { Name: 'given_name', Value: given_name },
        { Name: 'family_name', Value: family_name },
        { Name: 'email', Value: email },
        { Name: 'phone_number', Value: '+1' + phone.slice(3) }
      ]
    };

    if (!userToEdit) {
      userData.password = tempPassword;
    } else {
      userData.oldGroup = oldGroup;
    }

    const result = userToEdit
      ? await updateUser(userData)
      : await addUser(userData);

    if (result.statusCode === 200) {
      const oldGroup = userToEdit ? group : this.state.form.oldGroup;
      this.setState({
        message: userToEdit ? 'The user was updated.' : 'The user was created.',
        processing: false,
        form: { ...this.state.form, oldGroup }
      });
      if (!userToEdit) {
        this.clearFields();
      }
    } else {
      this.setState({
        errorMessage:
          (userToEdit
            ? 'The user was not updated.'
            : 'The user was not created.') +
          ' Error: ' +
          result.error,
        processing: false
      });
    }
  };

  validFields = () => {
    const { given_name, family_name, email, group, phone } = this.state.form;
    return (
      given_name !== '' &&
      family_name !== '' &&
      email !== '' &&
      group !== '' &&
      phone !== ''
    );
  };

  validEmail = () => {
    let validEmail = true;
    const regexEmail = new RegExp(
      "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
    );
    const email = this.state.form.email;

    if (email && !regexEmail.test(email.trim())) {
      validEmail = false;
    }

    return validEmail;
  };

  onGroupSelect = (event, data) => {
    const selectedGroup = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    this.setState({ form: { ...this.state.form, group: selectedGroup.value } });
  };

  render() {
    const { given_name, family_name, email, phone } = this.state.form;
    const { userToEdit } = this.props;
    return (
      <div>
        <h2>
          {userToEdit
            ? this.getAttribute(userToEdit, 'family_name') +
              ' ' +
              this.getAttribute(userToEdit, 'given_name')
            : 'New User'}
        </h2>
        <Divider />
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Image src={Images.userPlaceholder} size="medium" />
            </Grid.Column>
            <Grid.Column>
              {this.state.processing ? (
                <div>
                  <Loader inline className="active" />
                  Processing...
                  <Divider hidden />
                </div>
              ) : null}
              {this.state.message ? (
                <div className="manage-user-message-container">
                  <span>{this.state.message}</span>
                </div>
              ) : null}
              {this.state.errorMessage ? (
                <div className="manage-user-error-message-container">
                  <span>{this.state.errorMessage}</span>
                </div>
              ) : null}
              <Form.Input
                className="manage-user-input"
                placeholder="Given Name"
                type="text"
                name="given_name"
                value={given_name}
                onChange={this.handleFormChange}
              />
              <Divider hidden />
              <Form.Input
                className="manage-user-input"
                placeholder="Family Name"
                type="text"
                name="family_name"
                value={family_name}
                onChange={this.handleFormChange}
              />
              <Divider hidden />
              <Form.Input
                className="manage-user-input"
                placeholder="Email"
                type="text"
                name="email"
                value={email}
                onChange={this.handleFormChange}
              />
              <Divider hidden />
              <Form.Input
                className="manage-user-input"
                placeholder="Phone Number"
                type="text"
                name="phone"
                value={phone}
                onChange={this.handleFormChange}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Group"
                search
                selection
                options={this.state.groups}
                value={this.state.form.group}
                onChange={this.onGroupSelect}
              />
            </Grid.Column>
            <Grid.Column>
              <Button onClick={this.goBackSearch} size="small" color="grey">
                Cancel
              </Button>
              <Button onClick={this.createEditUser} size="small" color="blue">
                {userToEdit ? 'Update' : 'Create'}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageUser);



// WEBPACK FOOTER //
// ./src/screens/User/ManageUser.js